/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

// eslint-disable-next-line max-len
import {
    CategoryConfigurableAttributes as SourceCategoryConfigurableAttributes
} from 'SourceComponent/CategoryConfigurableAttributes/CategoryConfigurableAttributes.component';
import ExpandableContent from 'Component/ExpandableContent';
import ExpandableContentShowMore from 'Component/ExpandableContentShowMore';
import ProductAttributeValue from 'Component/ProductAttributeValue/ProductAttributeValue.component';
import Field from "Component/Field";
import matchSearchString from "../../util/String/Helper";

/** @namespace Component/CategoryConfigurableAttributes/Component */
export class CategoryConfigurableAttributes extends SourceCategoryConfigurableAttributes {

    state = {
        searchString: ''
    }

    renderConfigurableAttributeValue(attribute) {
        const {
            getIsConfigurableAttributeAvailable,
            handleOptionClick,
            getLink,
            isSelected,
            show_product_count,
            parameters
        } = this.props;

        const { attribute_value, attribute_code, attribute_options } = attribute;

        if(attribute_code === "category_id" || attribute_code === "category_ids"){
            let parentCheck = false;
            if (parameters["category_ids"] && attribute_options[parameters["category_ids"][0]]?.level == '4' &&
                attribute_options[attribute_value]?.parent_id == parameters["category_ids"][0]) {
                parentCheck = true;
            }
            if (parameters["category_ids"] && attribute_options[parameters["category_ids"][0]]?.level == '5' &&
                attribute_options[parameters["category_ids"][0]]?.parent_id == attribute_options[attribute_value]?.parent_id) {
                parentCheck = true;
            }
            if (parameters["category_id"] && attribute_options[parameters["category_id"][0]]?.level == '4' &&
                attribute_options[attribute_value]?.parent_id == parameters["category_id"][0]) {
                parentCheck = true;
            }
            if (parameters["category_id"] && attribute_options[parameters["category_id"][0]]?.level == '5' &&
                attribute_options[parameters["category_id"][0]]?.parent_id == attribute_options[attribute_value]?.parent_id) {
                parentCheck = true;
            }

            return (
                <ProductAttributeValue
                    key={ attribute_value }
                    attribute={ attribute }
                    isSelected={ isSelected(attribute) }
                    isParentSelected={ parentCheck }
                    isAvailable={ getIsConfigurableAttributeAvailable(attribute) }
                    onClick={ handleOptionClick }
                    getLink={ getLink }
                    isProductCountVisible={ show_product_count }
                />
            );
        }

        return (
            <ProductAttributeValue
                key={ attribute_value }
                attribute={ attribute }
                isSelected={ isSelected(attribute) }
                isAvailable={ getIsConfigurableAttributeAvailable(attribute) }
                onClick={ handleOptionClick }
                getLink={ getLink }
                isProductCountVisible={ show_product_count }
            />
        );
    }

    renderDropdown(option) {
        let {attribute_values, attribute_options, attribute_code} = option;
        const { searchString } = this.state;

        if (attribute_code === 'brand') {
            return (
                <div
                    block="ProductConfigurableAttributes"
                    elem="DropDownList"
                >
                    <Field nam='search' type='text' onChange={(value)=>this.setState({searchString: value})}></Field>
                    <ExpandableContentShowMore isCategoryFilter={ true } searchString={searchString}>
                        {attribute_values.map((attribute_value) => {
                            if(searchString && !matchSearchString(searchString,attribute_options[attribute_value].label) )
                                return null;
                            return (
                                this.renderConfigurableAttributeValue({...option, attribute_value})
                            );
                        })}
                    </ExpandableContentShowMore>
                </div>
            );
        }

        if(attribute_code === 'category_id' || attribute_code === 'category_ids'){
            let newAttributeValues = [];
            attribute_values.reduce((init,key)=>{
                if (attribute_options[key].level !== '1'){
                    newAttributeValues.push(key)
                }
                return init;
            },{});

            if(attribute_values.length < 1)
                return null
            attribute_values = newAttributeValues;

            return (
                <div
                    block="ProductConfigurableAttributes"
                    elem="DropDownList"
                >
                    {attribute_values.map((attribute_value) => (
                        this.renderConfigurableAttributeValue({...option, attribute_value})
                    ))}
                </div>
            );
        }

        return (
            <div
                block="ProductConfigurableAttributes"
                elem="DropDownList"
            >
                <ExpandableContentShowMore isCategoryFilter={ true }>
                    {attribute_values.map((attribute_value) => (
                        this.renderConfigurableAttributeValue({...option, attribute_value})
                    ))}
                </ExpandableContentShowMore>
            </div>
        );
    }

    renderDropdownOrSwatch(option) {
        const {
            isContentExpanded,
            getSubHeading
        } = this.props;

        let {
            attribute_label,
            attribute_code,
            attribute_values,
            attribute_options
        } = option;

        const [{ swatch_data }] = attribute_options ? Object.values(attribute_options) : [{}];
        const isSwatch = !!swatch_data;

        if(attribute_code === 'category_id'){
            attribute_values = [];

            Object.entries(attribute_options).reduce((init,[key,option])=>{
                if (option.level !== '1'){
                    attribute_values.push(key);
                }
                return init;
            },{});

            if(attribute_values.length < 1)
                return null
        }

        return (
            <ExpandableContent
                key={ attribute_code }
                heading={ attribute_label }
                subHeading={ getSubHeading(option) }
                mix={ {
                    block: 'ProductConfigurableAttributes',
                    elem: 'Expandable'
                } }
                isContentExpanded={ isContentExpanded }
            >
                { isSwatch ? this.renderSwatch(option) : this.renderDropdown(option) }
            </ExpandableContent>
        );
    }

    renderSubCategories(option) {
        return this.renderDropdownOrSwatch(option);
    }
}

export default CategoryConfigurableAttributes;
